module.exports = __webpack_public_path__ + "5a77dcac305d923d92c91057bfc2f0fc.png";